module.exports = __webpack_public_path__ + "static/media/Рогозина Н..4b6996e7.pdf";